import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GetOrdersResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "orders":
                    {
                        "number": "1999",
                        "state": "PENDING",
                        "invoice_number": "00012-12345678",
                        "customer": {
                            "code": "123",
                            "fantasy_name": "Client123",
                            "business_name": "Client123BN123",
                            "number": "1234",
                            "taxpayer_identification_number": 123,
                            "delivery_sites": [
                                {
                                    "name": "DeliverySite123",
                                    "address": "Calle123",
                                    "city": "CABA"
                                },
                                {
                                    "name": "DeliverySite456",
                                    "address": "Calle456",
                                    "city": "CABA"
                                }
                            ]
                        },
                        "customers_order_number": "",
                        "delivery_site": {
                            "name": "DeliverySite456",
                            "address": "Calle456",
                            "city": "CABA"
                        },
                        "delivery_date": "07-06-2024",
                        "observations": null,
                        'total_price': 10000.0000,
                        "articles": [
                            {
                                "article": {
                                    "code": "1999",
                                    "name": "naza-test-article",
                                    "fantasy_name": "fantasy-article",
                                    "items_amount": "1",
                                    "items_unit": "KG",
                                    "category": {
                                        "name": "category-name",
                                        "title": "category-title",
                                        "description": "a category description"
                                    }
                                },
                                "quantity": 2
                            },
                            {
                                "article": {
                                    "code": "789",
                                    "name": "second-fantasy-article",
                                    "fantasy_name": "second-fantasy-article",
                                    "items_amount": "1",
                                    "items_unit": "UNITS",
                                    "category": {
                                        "name": "category-name",
                                        "title": "category-title",
                                        "description": "a category description"
                                    }
                                },
                                "quantity": 1
                            },
                            {
                                // Only if state is INVOICED
                                "article": {
                                    "code": "1",
                                    "name": "Articulo",
                                    "fantasy_name": "Articulo Fantasia",
                                    "items_amount": "20",
                                    "items_unit": "KG",
                                    "category": {
                                        "name": "Categoria",
                                        "title": "Titulo Categoria",
                                        "description": "Descripcion Categoria"
                                    }
                                },
                                "quantity": 4,
                                "unit_price": {
                                    'amount': 60.00,
                                    'currency': "ARS"
                                },
                                "price": {
                                    'amount': 1200.00,
                                    'currency': "ARS"
                                }

                            }
                        ]
                    }
            },
            errors: []
        }
    }

    orders() {
        // TODO: Receive total amount from backend
        return this.content().orders.map(order => {
            return {
                    number: order.number,
                    state: this._adaptOrderState(order.state),
                    customer: this.customer(order.customer),
                    deliverySite: this.deliverySite(order.delivery_site),
                    deliveryDate: order.delivery_date,
                    observations: order.observations,
                    totalPrice: order.total_price,
                    articles: this.articles(order.state, order.articles),
                    invoiceNumber: order.invoice_number,
                    customersOrderNumber: order.customers_order_number
            }
        });
    }

    customer(customer) {
        return {
            code: customer.code,
            businessName: customer.business_name,
            customerCode: customer.code,
            fantasyName: customer.fantasy_name,
        }
    }

    deliverySite(deliverySite) {
        return {
            deliverySiteName: deliverySite.name,
            deliverySiteAddress: deliverySite.location.address,
            deliverySiteCity: deliverySite.location.city,
            deliveryDate: "",
        }
    }

    articles(state, articles) {
        return articles.map(articleWithAmount => {
            const article =  {
                code: articleWithAmount.article.code,
                name: articleWithAmount.article.name,
                family: articleWithAmount.article.category.title,
                amount: articleWithAmount.quantity,
                file: articleWithAmount.article.file,
                fantasyName: articleWithAmount.article.fantasy_name,
                itemsAmount: articleWithAmount.article.items_amount,
                itemsUnit: articleWithAmount.article.items_unit,
            }
            if (state === 'INVOICED') {
                article.fantasyName = articleWithAmount.article.fantasy_name
                article.price = articleWithAmount.price
                article.unitPrice = articleWithAmount.unit_price
                article.itemPrice = articleWithAmount.unit_price
            }
            return article
        })
    }

    _adaptOrderState(orderState) {
        if (orderState === "INITIAL") {
            return "ABIERTO"
        }
        if (orderState === "PENDING") {
            return "CERRADO"
        }
        if (orderState === "CONFIRMED") {
            return "PROCESO DE FACTURACIÓN"
        }
        if (orderState === "INVOICED") {
            return "FACTURADO"
        }
        if (orderState === "FAILED_TO_CONFIRMED") {
            return "FALLO EN TRANSMISIÓN"
        }
        if (orderState === "REVISION") {
            return "EN REVISIÓN"
        }
        if (orderState === "REJECTED") {
            return "RECHAZADO"
        }
    }
}